<template>
  <modal 
    name="mfa-confirm-modal-one" 
    :pivotY="0.2"
    :height="'auto'"
    :width="'560px'"
    @opened="opened"
    @before-open="beforeOpen">

    <!-- we are loading the pages right now -->
    <div class="border-b p-4 flex justify-between items-center">
      <div class="text-base text-gray-800">
        Verifying your mobile phone number
      </div>

      <a href="#"
        @click.prevent="$modal.hide('mfa-confirm-modal-one')"
        class="text-grey hover:text-grey-darker">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/img/feather-sprite.svg#x"/>
        </svg>
      </a>
    </div>
    
    <div class="p-4">

      <template v-if="error">
        <div class="text-base">
          There was an error when sending a message to your mobile phone.
          Please make sure that you have typed in a 

          <router-link
            :to="{
              name: 'broker-account',
              params : {
                brokerId : $route.params.brokerId
              }
            }"
            tag="a"
            class="underline">correct mobile phone number in your profile</router-link>.

          Once you have done that, you can come back and try again.
        </div>

        <div class="mt-8">
          <SubmitButton :onClick="close" :loading="loading" label="Got it." :isFullWidth="true" />
        </div>
      </template>

      <template v-else>
        <div class="text-base">
          To enable Multi-Factor Authentication, we are going to verify your mobile phone number.
          Please have your mobile phone available as we will be sending you a 6-digit code for you
          to type in. 
        </div>

        <div class="text-base mt-6">
          When you're ready, please click 
          <span class="text-blue-600 font-semibold">Verify my mobile phone number</span> button below.
        </div>

        <div class="mt-8">
          <SubmitButton :onClick="submit" :loading="loading" label="I'm ready. Verify my phone please." :isFullWidth="true" />
        </div>
      </template>

    </div>
  </modal>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import SubmitButton   from '@/shared/components/form/SubmitButton'

  export default {

    components : {
      SubmitButton
    },

    props : {
      sendMFAVerificationCode : {
        type    : Function,
        required: true
      }
    },

    data() {
      return {
        loading: false,
        error  : false
      }
    },

    methods : {

      beforeOpen(event) {
        this.loading = false
        this.error   = false
      },

      opened(event) {
        
      },

      close() {
        EventBus.$emit('refresh-user')
        this.$modal.hide('mfa-confirm-modal-one')
      },

      submit() {
        this.loading = true
        this.sendMFAVerificationCode( (data) => {
          this.loading = false

          if(data != null && data.error != null) {
            this.error = true
          }

          else {
            this.$modal.show('mfa-confirm-modal-two')
            this.$modal.hide('mfa-confirm-modal-one')            
          }
        })
      }
    }
  }
</script>